const DURATION_MS = 1400

function easeOutCubic(t) {
  return 1 - (1 - t) ** 3
}

function animateMetric({ el, target, prefix, suffix }) {
  const start = performance.now()

  const tick = (now) => {
    const elapsed = now - start
    const progress = Math.min(1, elapsed / DURATION_MS)
    const value = easeOutCubic(progress) * target
    el.textContent = `${prefix}${Math.round(value)}${suffix}`
    if (progress < 1) {
      requestAnimationFrame(tick)
    } else {
      el.textContent = `${prefix}${target}${suffix}`
    }
  }

  requestAnimationFrame(tick)
}

function readConfig(el) {
  const raw = el.getAttribute('data-target')
  const target = raw == null ? NaN : Number.parseFloat(raw)
  return {
    el,
    target: Number.isFinite(target) ? target : 0,
    prefix: el.getAttribute('data-prefix') ?? '',
    suffix: el.getAttribute('data-suffix') ?? '',
  }
}

function initExperienceMetrics() {
  const root = document.querySelector('[data-section="experience"]')
  if (!root) return

  const nodes = root.querySelectorAll('.js-experience-metric')
  if (!nodes.length) return

  const configs = [...nodes].map(readConfig)
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  let done = false

  const run = () => {
    if (done) return
    done = true
    configs.forEach((c) => {
      if (reducedMotion) {
        c.el.textContent = `${c.prefix}${c.target}${c.suffix}`
        return
      }
      animateMetric(c)
    })
  }

  if (reducedMotion) {
    run()
    return
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
          run()
          observer.disconnect()
        }
      })
    },
    { root: null, rootMargin: '0px 0px -8% 0px', threshold: [0, 0.25, 0.5] }
  )

  observer.observe(root)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initExperienceMetrics)
} else {
  initExperienceMetrics()
}
